import { DateTime } from 'luxon';
import { ON_ACCOUNT } from '../../variables';
import CashSaleDialogue from '../accept-dialogues/cash-sale-dialogue';
import ConfirmationDialogue from '../accept-dialogues/confirmation-dialogue';
import ConfirmationSuccess from '../accept-dialogues/confirmation-success';
import ErrorDialogue from '../accept-dialogues/error-dialogue';
import ExpiredDialogue from '../accept-dialogues/expired-dialogue';
import ProcessDialogue from '../accept-dialogues/process-dialogue';
import { useBookingContext, useAcceptStatus } from '../../context/BookingContext';

const AcceptanceDialog = ({ closeCallback }) => {

    const { booking } = useBookingContext();
    const { processingAccept, acceptSuccess, acceptError } = useAcceptStatus();

    const expired = (() => {
        if (booking?.quoteExpiry) {
            var expiryDate = DateTime.fromISO(booking.quoteExpiry);
            var now = DateTime.local();
            if (now >= expiryDate) {
                return true;
            } else {
                return false;
            }
        }
        return false;
    })();

    const cashSaleCustomer = booking?.paymentType !== ON_ACCOUNT;

    if (expired) {
        return (
            <div className="p-10"><ExpiredDialogue /></div>
        )
    }

    if (!cashSaleCustomer && acceptError) {
        return (
            <div className="p-10"><ErrorDialogue /></div>
        )
    }

    if (!cashSaleCustomer && acceptSuccess) {
        return (
            <div className="p-10"><ConfirmationSuccess closeCallback={closeCallback} /></div>
        )
    }

    if (!cashSaleCustomer && processingAccept) {
        return (
            <div className="p-10"><ProcessDialogue /></div>
        )
    }

    return (
        <div className="p-10">
            { cashSaleCustomer ? <CashSaleDialogue closeCallback={closeCallback} /> : <ConfirmationDialogue closeCallback={closeCallback} />}
        </div>
    )
}

export default AcceptanceDialog
